import { OneDSListener } from '@bingads-webui/oneds-listener';
import {
  getAriaConfig,
  PerformanceLogsFormatter,
  PerformanceLogsFilter,
} from '@bingads-webui-campaign/instrumentation';
import type { PerfLogListenersOptions } from './types';

export default function getPerfLogListeners(props?: PerfLogListenersOptions) {
  const { ariaConfig: applicationAriaConfig = {} } = props || {};

  const currentEnv = document.domain;
  const ariaConfig = {
    ...getAriaConfig(currentEnv),
    ...applicationAriaConfig,
  };

  // init log formatters
  const performanceLogsFormatter = new PerformanceLogsFormatter();

  // init log filters
  const performanceLogsFilter = new PerformanceLogsFilter();

  const perfLogListener = new OneDSListener({
    tenantToken: ariaConfig.token,
    batchSize: ariaConfig.batchSize,
    logTableNames: {
      resourcetiming: {
        name: 'resourcetiming',
      },
    },
    defaultLogCategory: 'resourcetiming',
    formatters: {
      performanceLogsFormatter,
    },
    filters: {
      performanceLogsFilter,
    },
  });

  perfLogListener.init();

  const listeners = {
    perfLogListener,
  };

  return listeners;
}
